// The actuation a task asks for, as the API serves it on GET /tasks, the quote
// reads and by-token (REC-1966): `actuationType`, `actuationTypeOther`,
// `addressType`, `conservador`, `procedure` and `recipients`. The labels are
// the API's own (`task-actuation.utils.ts`), so the email and the web read the
// same.

export const ACTUATION_LABELS = {
  BUSQUEDA_Y_CEDULA_44: 'Búsqueda y notificación por cédula (art. 44)',
  GESTION_CONSERVADOR: 'Gestión en el Conservador de Bienes Raíces',
  NOTIFICACION_CEDULA: 'Notificación por cédula',
  NOTIFICACION_PERSONAL: 'Notificación personal',
  OTRA: 'Otra',
  REQUERIMIENTO_PAGO_EMBARGO: 'Requerimiento de pago y embargo',
};

export const ADDRESS_TYPE_LABELS = {
  INSTITUCION: 'Institución',
  LABORAL: 'Laboral',
  PARTICULAR: 'Particular',
};

function text(value) {
  return typeof value === 'string' ? value.trim() : '';
}

// OTRA carries the text the firm typed, as the quote email shows it ("Otra:
// Retiro de especies"). A value outside the catalog is shown as it came, and a
// task from before REC-1966 has none.
export function actuationLabel(source) {
  const type = source?.actuationType;
  if (!type) return null;
  const label = ACTUATION_LABELS[type] ?? type;
  const other = type === 'OTRA' ? text(source.actuationTypeOther) : '';
  return other ? `${label}: ${other}` : label;
}

export function addressTypeLabel(type) {
  if (!type) return null;
  return ADDRESS_TYPE_LABELS[type] ?? type;
}

// The inscription the Conservador filing names, one field per datum. Null
// unless the actuation is GESTION_CONSERVADOR, which is how the API serves it.
export function conservadorFields(source) {
  const c = source?.conservador;
  if (!c) return null;
  return [
    ['Fojas', text(c.fojas)],
    ['Número', text(c.numero)],
    ['Año', text(c.anio)],
    ['Registro', text(c.registro)],
  ].filter(([, value]) => value);
}

// One line per recipient, worded as the quote email words it
// (`describeRecipient` in the API): who it is and where it is served, its own
// domicile or the task's.
export function recipientLines(source) {
  const list = Array.isArray(source?.recipients) ? source.recipients : [];
  return list.map((r) => {
    const n = Number(r?.representatives);
    const who =
      r?.kind === 'EMPRESA'
        ? n > 0
          ? `Empresa con ${n} ${n === 1 ? 'representante' : 'representantes'}`
          : 'Empresa'
        : 'Persona natural';
    const where = [
      text(r?.address),
      text(r?.addressDetails),
      text(r?.commune),
      text(r?.region),
    ]
      .filter(Boolean)
      .join(', ');
    if (!where) return `${who}, en el domicilio de la diligencia`;
    const kind = addressTypeLabel(r?.addressType);
    return `${who}: ${where}${kind ? ` (${kind.toLowerCase()})` : ''}`;
  });
}
